export const CRITICAL_ERRORS = {
	DEM037:
		'Algunos de los datos ingresados son inválidos. Por favor, verifica los campos e inténtalo nuevamente',
}

export const ERROR_MESSAGES = CRITICAL_ERRORS
